import {css} from "@emotion/react";

export const rootCss = css`
    display: grid;
    grid-template-columns: 1fr auto auto;
    grid-template-rows: auto auto;
    grid-template-areas: "phone statelabel ncalls" "phone state ncalls";
    align-items: center;
    padding-left: 36px;
    padding-right: 36px;
    row-gap: 5px;
`;
export const phoneCss = css` 
    grid-area: phone;
    align-self: center;
`;
export const stateCss = css` 
    grid-area: state;
    align-self: flex-start;
    justify-self: flex-end;
`;
export const stateLabelCss = css` 
    grid-area: statelabel;
    align-self: flex-end;
    justify-self: flex-end;
`;
export const ncallsCss = css` grid-area: ncalls; `;